
// import Typical from "react-typical"
import {Text} from "@chakra-ui/react"

function Typeing(){
    return(
        <Text>a 
          {/* <Typical 
          loop={Infinity}
          wrapper="b"
          steps={[
            "MERN Developer",1000,
            "Problem Solver",1000
          ]} 
          /> */}
        </Text>
    )
}
export default Typeing;